import(/* webpackMode: "eager" */ "/app/app/editor/[toolId]/page.tsx");
